<template>
  <div class="tab">
    <main class="page_container">
      <TableLogs :data="data" :loading="loading" :link-keys="linkKeys" :keys="keys" @fetch="onFetchData" />
    </main>
  </div>
</template>
<script>
import TableLogs from "@/core/components/TableLogs/index";
import logsMixin from "@/core/components/TableLogs/logsMixin";
import { ApiService } from "@/api";

export default {
  name: "ServersLogs",
  components: {
    TableLogs,
  },
  mixins: [logsMixin],
  data() {
    return {
      keys: [
        "id",
        "archive_size",
        "clean_archive",
        "server_cluster",
        "name",
        "server_mode",
        "nimble_version",
        "server_id",
        "server_name",
        "status",
        "max_cameras_count",
      ],
      linkKeys: {
        id: `${process.env.BASE_URL}#/servers/edit/`,
      },
    };
  },
  methods: {
    fetchLogs: ApiService.logs.getServersLogs,
  },
};
</script>
